import React from 'react'

function OrderOnline() {
  return (
    <div>
      order
    </div>
  )
}

export default OrderOnline
